<template>
    <v-overlay :opacity="0.8" :value="show" @click.prevent.native="$emit('close')">
      <v-container fluid class="max-width max-height">
        <v-col class="max-height">
        <v-row justify="end">
          <v-btn
            icon
            @click="$emit('close')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-row class="max-height" align-content="center" align="center" justify="center">
          <swiper class="swiper" :options="swiperOption">
            <swiper-slide v-for="(image, index) in images" :key="index">
              <img 
                :src="image" 
                @click.stop 
                style="max-height: fit-content; max-width: 100%; margin: auto;"
                :style="$vuetify.breakpoint.xlOnly ? 'max-width: 70%' : 'max-width: 100%'"
              />
            </swiper-slide>
            <template v-if="(images.length > 1)">
              <div class="swiper-pagination" slot="pagination" @click.stop></div>
              <div class="swiper-button-prev" slot="button-prev" @click.stop></div>
              <div class="swiper-button-next" slot="button-next" @click.stop></div>
            </template>
          </swiper>
        </v-row>
        </v-col>
      </v-container>
    </v-overlay>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  props: {
    images: Array,
    show: Boolean,
    initialSlide: Number,
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data () {
    return {
      orientation: (window.screen.orientation || {}).type || window.screen.mozOrientation || window.screen.msOrientation,
      swiperOption: {
        initialSlide: null,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: this.images.length > 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  watch: {
    initialSlide (value) {
      this.swiperOption.initialSlide = value
    },
  },
}
</script>


<style lang="scss">
.max-height {
  max-height: calc(100vh);
}
.max-width {
  max-width: calc(100vw);
}
.screen-width {
  width: 80%;
}
.swiper {
  *:focus {
    outline: none;
  }
  .swiper-button-next, .swiper-button-prev {
    color: white;
  }
  .swiper-pagination-bullet-active {
    background-color: white;
  }

  .swiper-slide {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
  }
}
</style>